<div
  *ngIf="definition && form"
  class="soft-list-item-action"
  [formGroup]="form"
>
  <input
    type="submit"
    class="soft-button primary"
    [value]="definition.title || ('#DYNAMIC.INPUT.SUBMIT' | translate)"
  />
</div>
